import store from "../store/index.js";

export const hasPermission = (permission) => {
    const state = store.getState();
    const { permissions } = state.Auth;
    return permissions.includes(permission);
}

export const hasPermissionModule = (permissionModule) => {
    const state = store.getState();
    const { permModules } = state.Auth;
    return permModules.includes(permissionModule);
}

export const extractModulesAndSubmodules = (permissions) => {
    const modulesSet = new Set();
    const submodulesSet = new Set();
    for (const permission of permissions) {
        const [module, submodule] = permission?.split('.') || [];
        if (module) modulesSet.add(module);
        if (submodule) submodulesSet.add(submodule);
    }
    return {
        permModules: [...modulesSet],
        permSubmodules: [...submodulesSet]
    };
};


export const filterMenuItems = (permModules, permSubmodules, items, permissions = []) => {
    return items.reduce((filteredItems, item) => {
        if (item.children) {
            const filteredChildren = filterMenuItems(permModules, permSubmodules, item.children, permissions);
            if (filteredChildren.length > 0) {
                filteredItems.push({ ...item, children: filteredChildren });
            }
        } 
        else if (item.permission) {
            if (permissions.includes(item.permission)) {
                filteredItems.push(item);
            }
        }
        else if (!item.module || permModules.includes(item.module)) {
            if (Array.isArray(item.submodules) && item.submodules.length > 0) {
                const hasAnySubmodulePermission = item.submodules.some((submodule) => permSubmodules.includes(submodule));
                if (hasAnySubmodulePermission) {
                    filteredItems.push(item);
                }
            } else if (item.submodule) {
                // Directly check against permSubmodules
                const hasSubmodulePermission = permSubmodules.includes(item.submodule);
                if (hasSubmodulePermission) {
                    filteredItems.push(item);
                }
            } else {
                filteredItems.push(item);
            }
        }
        return filteredItems;
    }, []);
};
